
import { PaginationProps, SortDirection } from '@touche-lts/panel-ui/dist/utilities'
import { CustomersTableHistorySearchProps, CustomerHistoryTableSortProps } from './customer-history-table-store.types'

export const initialDepartmentsTablePaginationProps: PaginationProps<CustomerHistoryTableSortProps> = {
    page: 0,
    size: 9,
    sortDirection: SortDirection.ASC,
    sortProp: CustomerHistoryTableSortProps.ID,
    totalElements: 0,
    totalPages: 0
}

export const initialCustomersHistoryTableSearchProps: CustomersTableHistorySearchProps = {}

export const customersTableNeedTimeoutHistorySearchProps: Array<keyof CustomersTableHistorySearchProps> = []